export default "__VITE_ASSET__D5lUyXCC__"